// Subdodávka (Mirko 16. 9. 2026): firma (s.r.o.) alebo SZČO, ktorá pre nás robí práce na zákazkách (napr. potery, výspravky).
// Je parťák, ak jej partia nemá iného parťáka (zobrazí sa v Rozpise prác); v partii s parťákom je členom partie (p40). IČO, rola a skupina
// sú povinné, úväzok nemá, typ platby je faktúra alebo hotovosť.
// Partner v Partneroch sa vytvorí alebo prepojí podľa IČO; jej faktúry sú náklad zákazky, nie mzda. Rovnaké pravidlá stráži server.
export const TYP_SUBDODAVKA = 'subdodavka'
export const PLATBY_SUBDODAVKY = ['faktúra', 'hotovosť']
export const jeSubdodavka = (v) => !!v && v.employee_type === TYP_SUBDODAVKA
export function chybySubdodavky(v) {
  const ch = []
  if (!String(v.firstName || '').trim() && !String(v.lastName || '').trim()) ch.push('názov alebo meno')
  if (String(v.ico || '').replace(/\D/g, '').length !== 8) ch.push('IČO (8 číslic)')
  if (!String(v.category || '').trim()) ch.push('skupina')
  if (!String(v.role || '').trim()) ch.push('rola')
  return ch
}

// p40 (Mirko 17. 9. 2026: „parťák ostane — budeme meniť iba kto bude faktúrovať“): parťák partie, ak je to INÝ zamestnanec než upravovaný.
// partie = /api/parties (partak_id, partak_name). Subdodávka v takej partii je členom; bez parťáka (alebo bez partie) je parťák.
export function inyPartakPartie(v, partie, id) {
  if (!v || !v.party) return null
  const p = (partie || []).find(x => x.id === v.party)
  if (!p || !p.has_partak || !p.partak_id || p.partak_id === id) return null
  return { id: p.partak_id, meno: p.partak_name || p.partak_id, partia: (p.name || p.id) + ' (' + p.id + ')' }
}
